<kendo-dialog (close)="onClose()">
    <kendo-dialog-titlebar>
        <div>{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Vehicle Specifications' } | translate }}</div>
    </kendo-dialog-titlebar>

    <div class="modal-content spec-modal-body">
        <div class="row g-3">
            <div class="col-4">
                <p class="small mb-2">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Category' } | translate }}</p>
                @if (store.loadingCategories()) {
                    <p class="text-muted small">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Loading categories...' } | translate }}</p>
                } @else if (store.categories().length > 0) {
                    <div class="list-group overflow-auto spec-list">
                        @for (category of store.categories(); track category.id) {
                            <button
                                type="button"
                                class="list-group-item list-group-item-action"
                                [class.active]="store.selectedCategoryId() === category.id"
                                (click)="store.pickCategory(category.id)"
                            >
                                {{ category.name }}
                            </button>
                        }
                    </div>
                } @else {
                    <p class="text-muted small">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'No specifications available for this vehicle.' } | translate }}</p>
                }
            </div>

            <div class="col-8">
                <p class="small mb-2">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Specifications' } | translate }}</p>
                @if (store.selectedCategoryId() === null) {
                    <p class="text-muted small">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Select a category to see its specifications.' } | translate }}</p>
                } @else if (store.loadingSpecs()) {
                    <p class="text-muted small">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Loading specifications...' } | translate }}</p>
                } @else if (store.specifications().length > 0) {
                    <div class="overflow-auto spec-list d-flex flex-column gap-3">
                        @for (spec of store.specifications(); track spec.applicationId) {
                            <div class="border-bottom pb-2">
                                <div class="fw-semibold">
                                    {{ spec.name }}
                                    @if (spec.position) {
                                        <span class="text-muted fw-normal">- {{ spec.position }}</span>
                                    }
                                </div>

                                @for (item of spec.items; track $index) {
                                    <div>
                                        {{ formatItem(item) }}
                                        @for (note of item.notes; track note) {
                                            <span class="text-muted small">({{ note }})</span>
                                        }
                                    </div>
                                }

                                @for (procedure of spec.procedures; track $index) {
                                    <div class="small">{{ procedure }}</div>
                                }

                                @for (note of spec.notes; track note) {
                                    <div class="text-muted small">{{ note }}</div>
                                }

                                @if (spec.attributes?.length ?? 0 > 0) {
                                    <div class="d-flex flex-wrap gap-1 mt-1">
                                        @for (attribute of spec.attributes; track attribute.name) {
                                            <span class="badge text-bg-light border">{{ attribute.text }}</span>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                } @else {
                    <p class="text-muted small">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'No specifications listed for this category.' } | translate }}</p>
                }
            </div>
        </div>
    </div>

    <kendo-dialog-actions layout="end">
        <button class="btn btn-sm btn-primary" (click)="onClose()">{{ { feature: 'Estimates', component: 'Vehicle Spec Modal', label: 'Close' } | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>
